const MeusPontos = () => import('@/views/MeusPontos.vue');

const routes = [
  {
    path: '/meus-pontos',
    name: 'meus-pontos',
    component: MeusPontos,
    meta: {
      title: 'Meus pontos',
    },
  },
];

export default routes;
